// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__Ox_bU","clinicsSelect":"TableHeading_clinicsSelect__2uY5O"};